export enum SetPropertyActionValue {
  Property = 'Property',
  Calculate = 'Calculate',
  Constant = 'Constant',
  Now = 'Now'
}

export default class BaseValue {
  type!: SetPropertyActionValue
}
